import React, {useContext} from "react";
import {Image, Pressable} from "react-native";
import MainStyle from "../../MainStyle";
import WhiteIconLogo from "../assets/img/small_logo.svg";
import {useNavigation} from "@react-navigation/native";
import {MaterialIcons} from '@expo/vector-icons';
import {colors} from "../assets/styles/colors";
import {StoreContext} from "./StoreContextProvider";
import WinCircleIcon from "../assets/img/icons/index.svg";
import {formatCurrency} from "../utils";
import Div from "../lib/Div";
import P from "../lib/P";

type Props = { pt?: string | number, pb?: string | number };

const NewHeader = (props: Props) => {
  const {pt, pb} = props;
  const navigation: any = useNavigation();
  const Context = useContext(StoreContext);
  const {balance, extendedUserData} = Context;

  return (
    <Div row pt={pt} pb={pb} alignItems="center">
      <Pressable style={MainStyle.m_l_21} onPress={() => navigation.navigate('challenges')}>
        <Image source={WhiteIconLogo as any} style={[MainStyle.w_42, MainStyle.h_48]}/>
      </Pressable>

      <Div flex={1}/>

      <Div mr={18}>
        <P color={colors.newGreenText} ta="center" fw="700" lh={14}>
          {extendedUserData.skillIndex > 99 ? '99+' : extendedUserData.skillIndex.toFixed(0)}
        </P>
        <Image source={WinCircleIcon as any} style={[MainStyle.w_36, MainStyle.h_12]}/>
      </Div>

      <Pressable style={styles.deposit} onPress={() => navigation.navigate({name: 'account', params: {step: 1}})}>
        <MaterialIcons name="add-circle-outline" size={24} color={colors.newGreenText}/>
        <P color={colors.newGreenText} fw="500" fs={20} ml={9}>{balance ? formatCurrency(balance / 100) : '$0'}</P>
      </Pressable>
    </Div>
  );
};

const styles = {
  deposit: [
    MainStyle.bg_deposit, MainStyle.h_48, MainStyle.p_l_16, MainStyle.p_r_20, MainStyle.row, MainStyle.a_i_c,
    MainStyle.b_t_l_r_28, MainStyle.b_b_l_r_28
  ]
};

export default React.memo(NewHeader);
